import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Components
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { TeamSection } from "@/components/TeamSection";
import { ServicesSection } from "@/components/ServicesSection";
import { ProcessSection } from "@/components/ProcessSection";
import { GallerySection } from "@/components/GallerySection";
import { StatsSection } from "@/components/StatsSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { PartnersSection } from "@/components/PartnersSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";
import { Chatbot } from "@/components/Chatbot";

const HomePage = () => {
  // State to manage chatbot open/close
  // This state is shared between FloatingButtons (to open) and Chatbot (to control Sheet)
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background overflow-x-hidden w-full max-w-full">
      <Navbar />
      <main className="overflow-x-hidden w-full max-w-full">
        <HeroSection />
        <AboutSection />
        <TeamSection />
        <ServicesSection />
        <ProcessSection />
        <GallerySection />
        <StatsSection />
        <TestimonialsSection />
        <PartnersSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingButtons 
        onChatbotOpen={() => setIsChatbotOpen(true)} 
        isChatbotOpen={isChatbotOpen}
      />
      <Chatbot isOpen={isChatbotOpen} onOpenChange={setIsChatbotOpen} />
      <Toaster position="top-right" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
